import { useGlobalSearchParams } from 'expo-router'
import type { ReactNode } from 'react'

import { SettingsLayout } from '@/src/features/settings/ui/layouts/SettingsLayout'

export default (): ReactNode => {
  const searchParams = useGlobalSearchParams()
  return <SettingsLayout searchParams={searchParams} />
}
